module.exports = __webpack_public_path__ + "static/media/logo.22aa5bf6.png";